import React from 'react';
import ReorderIcon from 'components/pure/utils/icon/ReorderIcon';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import SelectField from 'components/pure/utils/form/SelectField';
import QuestionTitleInput from 'components/pure/admin/QuestionTitleInput';
import CoachNotesEdit from 'components/pure/admin/CoachNotesEdit';
import WeightingInput from 'components/pure/admin/WeightingInput';
import {QUESTION_TYPE_TYPE as Q, RESPONDENT_TYPE as R} from 'records/CoachingReviewTypeQuestion';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import {TrashIcon} from '@components/icon/TrashIcon';

const questionTypeOptions = [
  {label: 'Text Area', value: Q.TextArea},
  {label: 'Text Field', value: Q.TextField},
  {label: '1-5 Score', value: Q.OneToFive},
  {label: '1-3 Score', value: Q.OneToThree},
  {label: 'Yes/No', value: Q.YesNo},
  {label: 'Pass/Fail', value: Q.PassFail},
];

const whoOptions = [
  {label: 'Coach', value: R.COACH},
  {label: 'Rep', value: R.REP},
];

export default class ReviewTypeQuestionRow extends React.PureComponent {
  respondentChanged(value) {
    this.props.onChange(this.props.index, 'respondent', value);
    this.props.onChange(this.props.index, 'optional', value !== R.REP);
  }

  render() {
    const {question, index, error, showErrors, blink} = this.props;
    let ref = null;
    return (
      <tr
        onDragOver={this.props.onDragOver}
        onDrop={e => this.props.onDrop(e, index)}
        ref={r => (ref = r)}>
        <td className="reorder-cell">
          <div
            className="pointer"
            draggable
            onDragStart={e => this.props.onDragStart(e, index, ref)}>
            <ReorderIcon />
          </div>
        </td>
        <td className="question-type-cell">
          <FieldContainer error={error.type}>
            <SelectField
              hideResetButton
              options={questionTypeOptions}
              value={question.type}
              onChange={type => this.props.onChangeQuestionType(index, type)}
            />
          </FieldContainer>
        </td>
        <td className="question-cell">
          <QuestionTitleInput
            index={index}
            text={question.text}
            onChange={this.props.onChange}
            showErrors={showErrors}
            error={error}
          />
        </td>
        <td>
          <CheckboxField
            checked={question.optional}
            onCheck={(_, value) => this.props.onChange(index, 'optional', value)}
          />
        </td>
        <td>
          <SelectField
            hideResetButton
            options={whoOptions}
            value={question.respondent}
            onChange={value => this.respondentChanged(value)}
          />
        </td>
        <td>
          <CoachNotesEdit
            coachNotes={question.coachNotes}
            onChange={val => this.props.onChange(index, 'coachNotes', val)}
          />
        </td>
        <td className="weight-cell">
          {!question.isText() && (
            // Don't render weight input for text-based questions
            <ScoreWeightingInput
              index={index}
              question={question}
              onChange={weight => this.props.onChange(index, 'weight', weight || 0)}
              onWeightBlur={this.props.onWeightBlur}
              blink={blink}
            />
          )}
        </td>
        <td className="trash">
          <TrashIcon
            className="pointer"
            onClick={() => this.props.deleteQuestion(index)}
            tooltip="Delete"
          />
        </td>
      </tr>
    );
  }
}

class ScoreWeightingInput extends React.PureComponent {
  render() {
    const {question, autofocusEdit, blink, onChange, onWeightBlur} = this.props;

    return (
      <WeightingInput
        wrapperClass="question-weight"
        inputKey={'call-weight-input-' + blink}
        val={question.weight}
        onChange={onChange}
        onBlur={onWeightBlur}
        autofocus={autofocusEdit}
        blink={blink}
      />
    );
  }
}
